module.exports = "/_next/static/images/ca0276abeabec732a322bc29e078db32-cuenta-zero-rate.svg.webp";